






import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { WxBaseWidget } from '../wxBaseWidget';

@Component({ name: 'wxSwitch' })
export default class WxSwitch extends WxBaseWidget {
    public get checked() {
        if (typeof this.item[this.fieldName] === 'number') {
            return this.item[this.fieldName] >= 1;
        } else if (typeof this.item[this.fieldName] === 'boolean') {
            return this.item[this.fieldName];
        } else if (typeof this.item[this.fieldName] === 'string') {
            return this.item[this.fieldName] === 'true';
        }
        return false;
    }

    public set checked(newValue: boolean) {
        let typedValue: number | boolean | string;

        if (typeof this.item[this.fieldName] === 'number') {
            typedValue = newValue ? 1 : 0;
        } else if (typeof this.item[this.fieldName] === 'boolean') {
            typedValue = newValue;
        } else if (typeof this.item[this.fieldName] === 'string') {
            typedValue = newValue ? 'true' : 'false';
        } else {
            typedValue = newValue;
        }

        this.item[this.fieldName] = typedValue;
        this.$emit('input', typedValue);
    }

    public get checkedHint() {
        const hints = this.computedHint.split('|');
        if (hints.length === 2) {
            return this.checked ? hints[0] : hints[1];
        }
        return '';
    }

    public get persistentHint() {
        return this.checkedHint !== '';
    }
}
